// import moment from 'moment'

export function displayTimeDiff(timeDiff) {
  if (timeDiff.asDays() >= 1) {
    return `${Math.floor(timeDiff.asDays())}d ${timeDiff.hours()}h ${timeDiff.minutes()}m`
  } else {
    return `${timeDiff.hours()}h ${timeDiff.minutes()}m ${timeDiff.seconds()}s`
  }
}